import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.admin');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.admin/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}`],
})
export class LayoutAdminComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const allowed = await this.service.auth.allow(true, "/auth/login");
        if (!allowed) return;

        const role = (this.service.auth?.session?.role ?? '').toString().toLowerCase();
        if (role !== 'admin') {
            this.service.href('/home');
            return;
        }

        await this.service.render();
    }
}

export default LayoutAdminComponent;